import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DBNDomainBasicInfoComponent from './dbn-domain-basic-info.component';
import DBNDomainAccountMappings from './dbn-domain-account-mappings';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';
import { useAppSelector } from '../../../../../../hooks/hooks';
import { selectListItems } from '../../../../../../redux/library/selector';
import DBNDomainProductMappings from './dbn-domain-products-mappings';

function DBNDomainComponent({
    handleInnerFormChange, selectedDBNDomain, domains, back, handleFormSubmit, id,
    handleFormItemChange, mediaFiles, changeImage,
}: any) {
    const libraryData = useAppSelector(selectListItems)

    const tabItems = [
        {
            id: 0,
            title: 'DBN Domain',
            component: <DBNDomainBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedDBNDomain={selectedDBNDomain}
                domains={domains}
            />,
            isVisible: true,
        },
        {
            id: 1,
            title: 'Media',
            component:
                <MediaInfoComponent
                    changeImage={changeImage}
                    // deleteSelectedProduct={deleteSelectedCategory}
                    fileTypes={libraryData?.result?.FileType}
                    //handleClose={handleClose}
                    //handleOpen={handleOpen}
                    onFormItemChange={handleFormItemChange}
                    // openConfirmation={openConfirmation}
                    mediaFiles={mediaFiles}
                //uploadToDigiiFolder={uploadToDigiiFolder}
                />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 2,
            title: 'Account Mappings',
            component: <DBNDomainAccountMappings
                id={id}
            />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Product Mappings',
            component: <DBNDomainProductMappings            
                selectedDBNDomain={selectedDBNDomain}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default DBNDomainComponent;
